<template>
  <b-container active @click="tabClick(2017)" :id="`electric-${year}`">
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Electricity Data <p/>
    </div>
    <b-button size="sm" @click="requestDownload()" v-if="admin">
      Export Electricity Data
    </b-button>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :columnDefs="columnDefs"
                 :rowData="rowData">
    </ag-grid-vue>

  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

const SizeEnum = {
  SO: 'solar',
  AG1: 'ag1',
  AG2: 'ag2',
  AG3: 'ag3'
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "VineyardSimplePowerMetricTable",
  props: {rows: Array, year: String, id: String, groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      metricYearVal: this.year,
      gridApi: null,
      gridColumnApi: null,
      columnDefs: null,
      defaultColDef: null,
      pinnedTopRowData: null,
      pinnedBottomRowData: null,
      topGridOptions: null,
      bottomGridOptions: null,
      rowData: this.rows,
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      metricId: this.id,
      myGroupId: this.groupId,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER'),
      admin: isAdmin()
    }
  },
  watch: {
    rows: function (newVal, _oldVal) {
      this.rowData = newVal;
    },
    year: function (newVal, _oldVal) {
      this.metricYearVal = newVal;
    },
    id: function (newVal, _oldVal) {
      this.metricId = newVal;
    },
    groupId: function (newVal, _oldVal) {
      this.myGroupId = newVal;
    }
  },
  beforeMount() {

    this.columnDefs = [
      {
        headerName: 'Month', field: 'meterUsage', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Solar Production (kWh)',
        field: 'solar',
        valueParser: numberParser,
        editable: false
      },
      {
        headerName: 'Ag Meter 1 (kWh)',
        field: 'ag1',
        valueParser: numberParser,
        editable: false
      },
      {
        headerName: 'Ag Meter 2 (kWh)',
        field: 'ag2',
        valueParser: numberParser,
        editable: false
      },
      {
        headerName: 'Ag Meter 3 (kWh)',
        field: 'ag3',
        valueParser: numberParser,
        editable: false
      },
    ];

    console.log(`The admin value: ${this.admin}`)
    let theGroup = this.myGroupId;
    this.$http.get("metrics/vineyard/power/graph/" + theGroup)
        .then(resultElectric => {
          let self = this;
          self.rowData = resultElectric.data;
        }).catch(
        error => {
          console.log(error)
        });
  },
  computed: {},
  methods: {
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/power/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
  }
}

function getPinnedTopData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}
</script>

<style scoped>

</style>
